import {AppBar, Toolbar, Typography} from '@material-ui/core';
import AllstateBenefitsLogo from 'Core/assets/images/AllstateBenefitsLogo.png';
import AccountMenu from 'Core/components/Navigation/AccountMenu';
import SearchBar from 'Core/components/Navigation/SearchBar';
import React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import withUserClaims, {WithClaimsProps} from 'Shared/components/withUserClaims';
import './LandingPageMenuBar.sass';
type MainAppBarProps = {} & WithClaimsProps;
export const LandingPageMenuBar = (props: MainAppBarProps & RouteComponentProps) => {
  return (
    <>
      <AppBar className="landing-page-menu-bar" position="static">
        <Toolbar>
          <div className="landing-page-menu-bar__content">
            <div className="landing-page-menu-bar__header">
              <img
                src={AllstateBenefitsLogo}
                id="main-logo"
                onClick={() => {
                  props.history.push('/');
                }}
                className="header__logo"
                alt="Allstate Benefits Logo"
              />
              <AccountMenu />
            </div>
            <Typography className="landing-page-menu-bar__welcome-message" variant="h6" color="inherit">
              Welcome {props.claims.firstName}
            </Typography>
            <SearchBar />
          </div>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default withUserClaims(withRouter(LandingPageMenuBar));
